import { not } from "../../shared/util/function";

const LIMIT = 3;
const STORAGE_KEY = "utm_page_entry";

export const PARAM_MTM_SOURCE = "mtm_source";
export const PARAM_MTM_MEDIUM = "mtm_medium";
export const PARAM_MTM_CAMPAIGN = "mtm_campaign";
const PARAM_UTM_SOURCE = "utm_source";
export const PARAM_UTM_MEDIUM = "utm_medium";
const PARAM_UTM_CAMPAIGN = "utm_campaign";

const extractDomain = urlString =>
	// remove subdomain 'www'
	new URL(urlString).host.replace(/^www\./, "");

const getQueryParam = param =>
	new URL(document.location).searchParams.get(param);

const getCurrent = () => {
	// From Url.
	if (getQueryParam(PARAM_MTM_SOURCE) || getQueryParam(PARAM_UTM_SOURCE)) {
		return {
			source:
				getQueryParam(PARAM_MTM_SOURCE) || getQueryParam(PARAM_UTM_SOURCE),
			medium:
				getQueryParam(PARAM_MTM_MEDIUM) || getQueryParam(PARAM_UTM_MEDIUM),
			campaign:
				getQueryParam(PARAM_MTM_CAMPAIGN) || getQueryParam(PARAM_UTM_CAMPAIGN),
		};
	}
	// From referrer.
	if (document.referrer) {
		const referrerDomain = extractDomain(document.referrer);
		return referrerDomain === extractDomain(document.location.origin)
			? null // Internal visit. No new Entry.
			: { source: referrerDomain, medium: "organic" };
	}
	// Direct traffic.
	return { source: "direct" };
};

const objEqual = obj1 => obj2 => JSON.stringify(obj1) === JSON.stringify(obj2);

let recentUtmSources = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

const current = getCurrent();
if (current) {
	// Requeue known entries.
	recentUtmSources = recentUtmSources.filter(not(objEqual(current)));
	recentUtmSources.unshift(current);

	while (recentUtmSources.length > LIMIT) {
		recentUtmSources.pop();
	}

	localStorage.setItem(STORAGE_KEY, JSON.stringify(recentUtmSources));
}

export const recent = recentUtmSources.length ? recentUtmSources[0] : null;

/*
 * Notice: this utm-string should fulfil a specific pattern `q1_|<source>|<medium>|<campaign>|q2_|...`.
 * This will be validated by the price controller.
 * When logic is changed, the validation should also be changed accordingly.
 * @see Prices/Controller.php
 */
export const getUtmQueryString = () =>
	recentUtmSources
		.map(({ source, medium, campaign }, index) => {
			const utmParams = [source, medium, campaign].filter(Boolean).join("|");
			return `q${index + 1}_|${utmParams}`;
		})
		.join("|");
